import React from "react";
import PropTypes from 'prop-types';
import { TextField } from "@material-ui/core";

import "../styles.css";

export default function Exercicio(props) {
    const {
        values,
        setValues,
        responsaveis,
        setUserExercio,
    } = props

    const handleUserSelect = (event) => {
        setValues({
            ...props.values,
            [event.target.id]: event.target.value,
        });
        setUserExercio(event.target.value)
    };

    return (
        <>
            <div className="titles">Informações Básicas</div>
            <div className="fundo">
                <div style={{ maxHeight: 100, overflow: 'auto' }}>
                    <div className="rowForm">

                        <div className="funcao">
                            <TextField
                                disabled={true}
                                margin="dense"
                                id="nome"
                                label="Função"
                                value={values.funcao}
                            />
                        </div>

                        <div className="funcao">
                            <TextField
                                select
                                id="exercicio"
                                size="small"
                                label="Funcionário em Exercício"
                                variant="outlined"
                                value={values.exercicio}
                                onChange={handleUserSelect}
                                SelectProps={{ native: true }}
                            >
                                {responsaveis.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </TextField>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

Exercicio.propTypes = {
    values: PropTypes.object,
    setValues: PropTypes.func,
    responsaveis: PropTypes.object,
};
